/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_CompInputs */

const en_plan_comp = /** @type {(inputs: Plan_CompInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complimentary access`)
};

const es_plan_comp = /** @type {(inputs: Plan_CompInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso de cortesía`)
};

/**
* | output |
* | --- |
* | "Complimentary access" |
*
* @param {Plan_CompInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_comp = /** @type {((inputs?: Plan_CompInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_CompInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_comp(inputs)
	return en_plan_comp(inputs)
});